import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ReqInviteMember, type ReqRemoveInvitedMember, type ResInviteMember } from './types'

export const inviteMemberMutation: MutationOptions<ResInviteMember, unknown, ReqInviteMember> = {
  mutationFn: (payload) => w.post(payload, API_ENDPOINTS.business.v1.user.invite.index).json(),
}

export const removeInvitedMemberMutation: MutationOptions<Record<string, never>, unknown, ReqRemoveInvitedMember> = {
  mutationFn: (payload) => w.json(payload).delete(API_ENDPOINTS.business.v1.user.invite.index).json(),
}
